// import React, { useEffect, useMemo, useState } from "react";
// import { useSelector } from "react-redux";
// import axios from "axios";
// import Loader from "../components/Loader";
// import {
//   ResponsiveContainer,
//   AreaChart,
//   Area,
//   XAxis,
//   YAxis,
//   Tooltip,
//   CartesianGrid,
//   ReferenceLine,
//   Line,
// } from "recharts";
// import {
//   FiRefreshCw,
//   FiUser,
//   FiActivity,
//   FiZap,
//   FiClock,
//   FiSearch,
//   FiLayers,
//   FiChevronLeft,
//   FiChevronRight,
//   FiFilter,
//   FiTerminal,
//   FiAlertCircle,
// } from "react-icons/fi";

// const UsageMonitoring = () => {
//   const token = useSelector((state) => state.user.token);

//   // --- ADMIN THRESHOLD STATE ---
//   const [adminMaxCalls, setAdminMaxCalls] = useState(() => {
//     const saved = localStorage.getItem("adminMaxCalls");
//     // Parse to number immediately; if NaN or null, use 100
//     const initialValue = Number(saved);
//     return !isNaN(initialValue) && saved !== null ? initialValue : 100;
//   });
//   // --- DATE STATES ---
//   const [startDate, setStartDate] = useState(() => {
//     const d = new Date();
//     return new Date(d.getFullYear(), d.getMonth(), d.getDate() - 7)
//       .toISOString()
//       .split("T")[0];
//   });
//   const [endDate, setEndDate] = useState(
//     () => new Date().toISOString().split("T")[0],
//   );

//   // --- USAGE STATES ---
//   const [usersUsage, setUsersUsage] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedUserId, setSelectedUserId] = useState(null);
//   const [userSearch, setUserSearch] = useState("");

//   // --- LOGS & FILTERS ---
//   const [logs, setLogs] = useState([]);
//   const [logsLoading, setLogsLoading] = useState(false);
//   const [logsPage, setLogsPage] = useState(1);
//   const [logsLimit, setLogsLimit] = useState(10);
//   const [logsTotalPages, setLogsTotalPages] = useState(1);
//   const [logFilters, setLogFilters] = useState({
//     action: "",
//     api: "",
//     source: "",
//     status: "",
//   });

//   // Hardcoded constant for speed (can be made dynamic too if needed)
//   const MAX_API_SPEED = 5;

//   const fetchAllUsage = async () => {
//     if (!token) return;
//     setLoading(true);
//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/api/usage/all`,
//         { startDate, endDate },
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       const payload = Array.isArray(res.data) ? res.data : res.data?.data || [];
//       const map = new Map();

//       payload.forEach((item) => {
//         const id = item.userId || item._id;
//         if (!id) return;
//         if (!map.has(id)) {
//           map.set(id, {
//             userId: id,
//             userName: item.userName || item.name || "User",
//             cron: item.cron || "No schedule set",
//             data: [],
//           });
//         }
//         const entry = map.get(id);
//         const dataPoints = Array.isArray(item.data) ? item.data : [item];
//         dataPoints.forEach((d) => {
//           if (d.date)
//             entry.data.push({
//               date: d.date,
//               calls: Number(d.calls) || 0,
//               speed: Number(d.speed) || 0,
//             });
//         });
//       });

//       const normalized = Array.from(map.values()).map((u) => {
//         const byDate = {};
//         u.data.forEach((d) => {
//           if (!byDate[d.date])
//             byDate[d.date] = { date: d.date, calls: 0, speedSum: 0, count: 0 };
//           byDate[d.date].calls += d.calls;
//           byDate[d.date].speedSum += d.speed;
//           byDate[d.date].count++;
//         });
//         const series = Object.values(byDate)
//           .map((v) => ({
//             date: v.date,
//             calls: v.calls,
//             speed: Number((v.speedSum / v.count).toFixed(2)),
//           }))
//           .sort((a, b) => a.date.localeCompare(b.date));
//         return { ...u, data: series };
//       });

//       setUsersUsage(normalized);
//       if (!selectedUserId && normalized.length)
//         setSelectedUserId(normalized[0].userId);
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchUserLogs = async (page = 1) => {
//     if (!token || !selectedUserId) return;
//     setLogsLoading(true);
//     try {
//       const body = {
//         userId: selectedUserId,
//         page,
//         limit: logsLimit,
//         ...logFilters,
//       };
//       const res = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/api/usage/user/logs`,
//         body,
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       setLogs(res.data.data || []);
//       setLogsTotalPages(res.data.pagination?.totalPages || 1);
//       setLogsPage(page);
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setLogsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAllUsage();
//   }, [startDate, endDate, token]);
//   useEffect(() => {
//     if (selectedUserId) fetchUserLogs(1);
//   }, [selectedUserId, logFilters, logsLimit]);

//   const filteredUsers = useMemo(() => {
//     return usersUsage
//       .map((u) => ({
//         ...u,
//         totalCalls: u.data.reduce((sum, d) => sum + d.calls, 0),
//       }))
//       .filter((u) =>
//         u.userName.toLowerCase().includes(userSearch.toLowerCase()),
//       )
//       .sort((a, b) => b.totalCalls - a.totalCalls);
//   }, [usersUsage, userSearch]);

//   const selectedUser = useMemo(
//     () =>
//       filteredUsers.find((u) => u.userId === selectedUserId) ||
//       filteredUsers[0],
//     [filteredUsers, selectedUserId],
//   );

//   const formatTs = (ts) => {
//     const d = new Date(Number(ts));
//     return (
//       <div className="flex flex-col text-[11px]">
//         <span className="font-bold text-slate-700">
//           {d.toLocaleDateString()}
//         </span>
//         <span className="text-slate-400 font-medium">
//           {d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
//         </span>
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-screen bg-[#F1F5F9] text-slate-900 p-4 md:p-8 space-y-6">
//       <header className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
//         <div>
//           <h1 className="text-3xl font-black text-slate-900 tracking-tight flex items-center gap-3">
//             System Monitor
//           </h1>
//         </div>

//         <div className="flex flex-wrap items-center gap-4">
//           {/* --- ADMIN THRESHOLD INPUT --- */}
//           <div className="flex items-center gap-2 bg-slate-900 text-white px-4 py-2 rounded-2xl shadow-lg border border-slate-700">
//             <FiAlertCircle className="text-rose-400" />
//             <label className="text-[10px] font-black uppercase tracking-wider">
//               Alert Threshold:
//             </label>
//             <input
//               type="number"
//               value={adminMaxCalls}
//               onChange={(e) => {
//                 setAdminMaxCalls(Number(e.target.value));
//                 localStorage.setItem("adminMaxCalls", e.target.value);
//               }}
//               className="bg-slate-800 border-none text-xs font-bold text-rose-400 w-16 rounded-lg focus:ring-rose-500 p-1 text-center"
//             />
//           </div>

//           <div className="flex items-center gap-2 bg-white p-2 rounded-2xl shadow-sm border border-slate-200">
//             <input
//               type="date"
//               value={startDate}
//               onChange={(e) => setStartDate(e.target.value)}
//               className="bg-transparent border-none text-xs font-bold text-slate-600 focus:ring-0 p-0 px-2"
//             />
//             <span className="text-slate-300">-</span>
//             <input
//               type="date"
//               value={endDate}
//               onChange={(e) => setEndDate(e.target.value)}
//               className="bg-transparent border-none text-xs font-bold text-slate-600 focus:ring-0 p-0 px-2"
//             />
//             <button
//               onClick={fetchAllUsage}
//               className="p-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl transition-all shadow-md active:scale-95"
//             >
//               <FiRefreshCw className={loading ? "animate-spin" : ""} />
//             </button>
//           </div>
//         </div>
//       </header>

//       <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
//         <aside className="lg:col-span-3">
//           <div className="bg-white rounded-[2rem] border border-slate-200 shadow-sm flex flex-col h-[750px] overflow-hidden">
//             <div className="p-5 border-b border-slate-50 bg-slate-50/50">
//               <div className="relative">
//                 <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
//                 <input
//                   type="text"
//                   placeholder="Search entity..."
//                   className="w-full pl-9 pr-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-blue-500"
//                   value={userSearch}
//                   onChange={(e) => setUserSearch(e.target.value)}
//                 />
//               </div>
//             </div>
//             <div className="overflow-y-auto flex-1 p-3 space-y-2">
//               {filteredUsers.map((u) => {
//                 // Check if this specific user has crossed the admin-defined limit
//                 const isOverLimit = u.totalCalls > adminMaxCalls;

//                 return (
//                   <button
//                     key={u.userId}
//                     onClick={() => setSelectedUserId(u.userId)}
//                     className={`w-full p-4 rounded-2xl transition-all flex items-center justify-between border-2 ${
//                       selectedUserId === u.userId
//                         ? "bg-slate-900 border-slate-900 text-white shadow-lg"
//                         : isOverLimit
//                           ? "bg-amber-50 border-amber-400 text-amber-900 animate-pulse" // Highlight crossers
//                           : "bg-white border-transparent hover:border-slate-200 text-slate-600"
//                     }`}
//                   >
//                     <div className="text-left">
//                       <div className="flex items-center gap-2">
//                         <div className="text-sm font-bold truncate w-24">
//                           {u.userName}
//                         </div>
//                         {/* Add a tiny warning icon if they are over the limit */}
//                         {isOverLimit && (
//                           <FiAlertCircle className="text-amber-600" size={12} />
//                         )}
//                       </div>
//                       <div className="text-[10px] font-mono opacity-50">
//                         {u.userId.slice(-6)}
//                       </div>
//                     </div>
//                     <div
//                       className={`text-right text-xs font-black ${isOverLimit && selectedUserId !== u.userId ? "text-amber-600" : ""}`}
//                     >
//                       {u.totalCalls}
//                     </div>
//                   </button>
//                 );
//               })}
//             </div>
//           </div>
//         </aside>

//         <main className="lg:col-span-9 space-y-6">
//           <div className="bg-white rounded-[2rem] border border-slate-200 shadow-sm p-8">
//             <div className="flex items-center justify-between mb-8">
//               <h3 className="text-xl font-black text-slate-800 tracking-tight">
//                 {selectedUser?.userName}'s API Usages
//               </h3>
//               <div className="flex gap-4 text-xs font-bold text-slate-400">
//                 <span className="flex items-center gap-1">
//                   <div className="w-2 h-2 rounded-full bg-blue-500" /> Calls
//                 </span>
//                 <span className="flex items-center gap-1">
//                   <div className="w-2 h-2 rounded-full bg-emerald-500" /> Speed
//                 </span>
//               </div>
//             </div>
//             <div className="h-[320px] w-full">
//               <ResponsiveContainer>
//                 <AreaChart data={selectedUser?.data}>
//                   <defs>
//                     <linearGradient id="blueG" x1="0" y1="0" x2="0" y2="1">
//                       <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.1} />
//                       <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} />
//                     </linearGradient>
//                   </defs>
//                   <CartesianGrid
//                     strokeDasharray="3 3"
//                     vertical={false}
//                     stroke="#f1f5f9"
//                   />
//                   <XAxis
//                     dataKey="date"
//                     axisLine={false}
//                     tickLine={false}
//                     tick={{ fill: "#94a3b8", fontSize: 11 }}
//                     dy={10}
//                   />
//                   <YAxis
//                     axisLine={false}
//                     tickLine={false}
//                     tick={{ fill: "#94a3b8", fontSize: 11 }}
//                   />
//                   <Tooltip content={<ChartTooltip />} />

//                   {/* --- DYNAMIC REFERENCE LINE --- */}
//                   <ReferenceLine
//                     y={adminMaxCalls}
//                     stroke="red"
//                     strokeDasharray="3 3"
//                     label={{
//                       position: "right",
//                       value: `Limit: ${adminMaxCalls}`,
//                       fill: "red",
//                       fontSize: 10,
//                       fontWeight: "bold",
//                     }}
//                   />

//                   <Area
//                     type="monotone"
//                     dataKey="calls"
//                     stroke="#3b82f6"
//                     strokeWidth={3}
//                     fill="url(#blueG)"
//                   />
//                   <Line
//                     type="monotone"
//                     dataKey="speed"
//                     stroke="#10b981"
//                     strokeWidth={2}
//                     dot={{ r: 4, fill: "#10b981" }}
//                   />
//                 </AreaChart>
//               </ResponsiveContainer>
//             </div>
//           </div>

//           <div className="bg-white rounded-[2rem] border border-slate-200 shadow-sm overflow-hidden flex flex-col">
//             <div className="p-6 border-b border-slate-50 bg-slate-50/30">
//               <div className="flex flex-wrap items-center gap-3">
//                 <div className="flex flex-col gap-1">
//                   <label className="text-[10px] font-black text-slate-400 uppercase ml-1">
//                     Action
//                   </label>
//                   <input
//                     type="text"
//                     placeholder="devicesync..."
//                     value={logFilters.action}
//                     onChange={(e) =>
//                       setLogFilters((p) => ({ ...p, action: e.target.value }))
//                     }
//                     className="text-xs border-slate-200 rounded-xl px-3 py-2 w-32 focus:ring-blue-500"
//                   />
//                 </div>
//                 <div className="flex flex-col gap-1">
//                   <label className="text-[10px] font-black text-slate-400 uppercase ml-1">
//                     API
//                   </label>
//                   <button
//                     onClick={() =>
//                       setLogFilters((p) => ({
//                         ...p,
//                         api: p.api === "tapo" ? "" : "tapo",
//                       }))
//                     }
//                     className={`text-xs font-bold px-4 py-2 rounded-xl border transition-all ${logFilters.api === "tapo" ? "bg-blue-600 text-white border-blue-600" : "bg-white text-slate-600"}`}
//                   >
//                     tapo
//                   </button>
//                 </div>
//                 <div className="flex flex-col gap-1">
//                   <label className="text-[10px] font-black text-slate-400 uppercase ml-1">
//                     Source
//                   </label>
//                   <select
//                     value={logFilters.source}
//                     onChange={(e) =>
//                       setLogFilters((p) => ({ ...p, source: e.target.value }))
//                     }
//                     className="text-xs border-slate-200 rounded-xl px-3 py-2 bg-white font-bold"
//                   >
//                     <option value="">All Sources</option>
//                     <option value="user">user</option>
//                     <option value="cron">cron</option>
//                     <option value="system">system</option>
//                     <option value="smartRestore">smartRestore</option>
//                   </select>
//                 </div>
//                 <div className="flex flex-col gap-1">
//                   <label className="text-[10px] font-black text-slate-400 uppercase ml-1 text-center">
//                     Status
//                   </label>
//                   <div className="flex items-center gap-3 bg-white border border-slate-200 rounded-xl px-3 py-1.5">
//                     {["", "success", "failed"].map((s) => (
//                       <label
//                         key={s}
//                         className="flex items-center gap-1 text-[10px] font-bold cursor-pointer"
//                       >
//                         <input
//                           type="radio"
//                           name="st"
//                           checked={logFilters.status === s}
//                           onChange={() =>
//                             setLogFilters((p) => ({ ...p, status: s }))
//                           }
//                           className="w-3 h-3 text-blue-600 focus:ring-0"
//                         />
//                         <span className="capitalize">{s || "All"}</span>
//                       </label>
//                     ))}
//                   </div>
//                 </div>
//                 <div className="flex items-end gap-2 pt-5">
//                   <button
//                     onClick={() => fetchUserLogs(1)}
//                     className="px-5 py-2 bg-slate-900 text-white text-[11px] font-black rounded-xl hover:bg-blue-600 transition-all"
//                   >
//                     APPLY
//                   </button>
//                   <button
//                     onClick={() =>
//                       setLogFilters({
//                         action: "",
//                         api: "",
//                         source: "",
//                         status: "",
//                       })
//                     }
//                     className="px-5 py-2 bg-slate-100 text-slate-600 text-[11px] font-black rounded-xl"
//                   >
//                     RESET
//                   </button>
//                 </div>
//               </div>
//             </div>

//             <div className="overflow-x-auto min-h-[400px]">
//               <table className="w-full text-left">
//                 <thead className="bg-slate-50/80">
//                   <tr className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
//                     <th className="px-6 py-4">Timestamp</th>
//                     <th className="px-6 py-4">Execution Info</th>
//                     <th className="px-6 py-4 text-center">Source</th>
//                     <th className="px-6 py-4 text-center">Status</th>
//                     <th className="px-6 py-4 text-center">Retry</th>
//                     <th className="px-6 py-4 text-right">Log Hash</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-slate-100 text-sm">
//                   {logsLoading ? (
//                     <tr>
//                       <td
//                         colSpan={6}
//                         className="p-20 text-center text-slate-400 animate-pulse font-bold"
//                       >
//                         <Loader />
//                       </td>
//                     </tr>
//                   ) : (
//                     logs.map((log) => (
//                       <tr
//                         key={log._id}
//                         className="hover:bg-blue-50/30 transition-all group"
//                       >
//                         <td className="px-6 py-4">{formatTs(log.timestamp)}</td>
//                         <td className="px-6 py-4">
//                           <div className="flex flex-col">
//                             <span className="font-bold text-slate-800">
//                               {log.action || "N/A"}
//                             </span>
//                             <span className="text-[10px] text-blue-500 font-black uppercase tracking-tighter">
//                               {log.api}
//                             </span>
//                           </div>
//                         </td>
//                         <td className="px-6 py-4 text-center">
//                           <span
//                             className={`px-2 py-1 rounded-md text-[10px] font-bold ${
//                               log.source === "cron"
//                                 ? "bg-amber-100 text-amber-700"
//                                 : "bg-slate-100 text-slate-600"
//                             }`}
//                           >
//                             {log.source}
//                           </span>
//                         </td>
//                         <td className="px-6 py-4 text-center">
//                           <span
//                             className={`px-2 py-1 rounded-full text-[10px] font-black uppercase tracking-tighter ${
//                               log.status === "success"
//                                 ? "bg-emerald-100 text-emerald-700"
//                                 : "bg-rose-100 text-rose-700"
//                             }`}
//                           >
//                             {log.status}
//                           </span>
//                         </td>
//                         <td className="px-6 py-4 text-center">
//                           <span
//                             className={`text-xs font-bold ${log.retryAttempt > 0 ? "text-orange-500" : "text-slate-300"}`}
//                           >
//                             {log.retryAttempt || 0}
//                           </span>
//                         </td>
//                         <td className="px-6 py-4 text-right">
//                           <span className="text-[10px] font-mono text-slate-300 group-hover:text-slate-500">
//                             #{log._id.slice(-6)}
//                           </span>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             <div className="p-6 bg-slate-50 border-t flex items-center justify-between">
//               <div className="flex items-center gap-2">
//                 <select
//                   value={logsLimit}
//                   onChange={(e) => setLogsLimit(Number(e.target.value))}
//                   className="text-[11px] font-bold border-slate-200 rounded-lg py-1 px-2"
//                 >
//                   {[10, 20, 50].map((n) => (
//                     <option key={n} value={n}>
//                       {n} rows
//                     </option>
//                   ))}
//                 </select>
//                 <span className="text-xs font-bold text-slate-400 ml-4 italic">
//                   Page {logsPage} of {logsTotalPages}
//                 </span>
//               </div>
//               <div className="flex gap-2">
//                 <button
//                   disabled={logsPage === 1}
//                   onClick={() => fetchUserLogs(logsPage - 1)}
//                   className="p-2 bg-white border rounded-xl disabled:opacity-30"
//                 >
//                   <FiChevronLeft />
//                 </button>
//                 <button
//                   disabled={logsPage === logsTotalPages}
//                   onClick={() => fetchUserLogs(logsPage + 1)}
//                   className="p-2 bg-white border rounded-xl disabled:opacity-30"
//                 >
//                   <FiChevronRight />
//                 </button>
//               </div>
//             </div>
//           </div>
//         </main>
//       </div>
//     </div>
//   );
// };

// const ChartTooltip = ({ active, payload, label }) => {
//   if (active && payload && payload.length) {
//     return (
//       <div className="bg-slate-900 p-4 rounded-2xl shadow-xl text-white">
//         <p className="text-[10px] font-black text-blue-400 uppercase mb-2">
//           {label}
//         </p>
//         <div className="flex gap-4">
//           <div>
//             <div className="text-[9px] text-slate-400 uppercase">Hits</div>
//             <div className="text-lg font-black">{payload[0].value}</div>
//           </div>
//           <div className="w-[1px] bg-slate-700 h-8 mt-1" />
//           <div>
//             <div className="text-[9px] text-slate-400 uppercase">Speed</div>
//             <div className="text-lg font-black text-emerald-400">
//               {payload[1]?.value}s
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
//   return null;
// };

// export default UsageMonitoring;

import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import UsageLogsTable from "../components/usage/UsageLogsTable";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ReferenceLine,
  Line,
} from "recharts";
import {
  FiRefreshCw,
  FiSearch,
  FiChevronLeft,
  FiChevronRight,
  FiAlertCircle,
  FiGlobe,
} from "react-icons/fi";

const UsageMonitoring = () => {
  const token = useSelector((state) => state.user.token);

  // --- SETTINGS ---
  const [adminMaxCalls, setAdminMaxCalls] = useState(() => {
    const saved = localStorage.getItem("adminMaxCalls");
    return saved ? Number(saved) : 100;
  });

  const [activeBrand, setActiveBrand] = useState("tapo"); 

  // --- DATE STATES ---
  const [startDate, setStartDate] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() - 30);
    return d.toISOString().split("T")[0];
  });
  const [endDate, setEndDate] = useState(() => new Date().toISOString().split("T")[0]);

  // --- DATA STATES ---
  const [rawUsageData, setRawUsageData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null); 
  
  // PERFORMANCE FIX: Use a local state for input to prevent typing lag
  const [userSearch, setUserSearch] = useState("");

  // --- LOGS ---
  const [logs, setLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);
  const [logsPage, setLogsPage] = useState(1);
  const [logsLimit, setLogsLimit] = useState(10);
  const [logsTotalPages, setLogsTotalPages] = useState(1);
  const [logFilters, setLogFilters] = useState({
    action: "",
    api: "", // Brand Filter for Logs
    source: "", 
    status: "",
  });

  const fetchAnalytics = async () => {
    if (!token) return;
    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/usage/all`,
        { startDate, endDate },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRawUsageData(res.data?.data || []);
    } catch (e) { console.error(e); } finally { setLoading(false); }
  };

  const fetchUserLogs = useCallback(async (page = 1) => {
    if (!token) return;
    setLogsLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/usage/user/logs`,
        { userId: selectedUserId, page, limit: logsLimit, ...logFilters },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setLogs(res.data.data || []);
      setLogsTotalPages(res.data.pagination?.totalPages || 1);
      setLogsPage(page);
    } catch (e) { console.error(e); } finally { setLogsLoading(false); }
  }, [token, selectedUserId, logsLimit, logFilters]);

  useEffect(() => { fetchAnalytics(); }, [startDate, endDate, token]);
  useEffect(() => { fetchUserLogs(1); }, [fetchUserLogs]);

  // PERFORMANCE FIX: Memoize sidebar users to prevent unnecessary loops
  const sidebarUsers = useMemo(() => {
    const userMap = new Map();
    rawUsageData.forEach(item => {
      if (!item.userId) return;
      if (!userMap.has(item.userId)) {
        userMap.set(item.userId, { userId: item.userId, userName: item.userName || "Unknown", totalCalls: 0 });
      }
      userMap.get(item.userId).totalCalls += item.calls;
    });
    return Array.from(userMap.values())
      .filter(u => u.userName.toLowerCase().includes(userSearch.toLowerCase()))
      .sort((a, b) => b.totalCalls - a.totalCalls);
  }, [rawUsageData, userSearch]);

  const chartData = useMemo(() => {
    const filtered = selectedUserId ? rawUsageData.filter(d => d.userId === selectedUserId) : rawUsageData;
    const dateMap = new Map();
    filtered.forEach(d => {
      if (!dateMap.has(d.date)) dateMap.set(d.date, { ...d, calls: 0, speed: 0, tapo: 0, honeywell: 0 });
      const existing = dateMap.get(d.date);
      existing.calls += d.calls;
      existing.tapo += d.tapo || 0;
      existing.honeywell += d.honeywell || 0;
      existing.speed = Math.max(existing.speed, d.speed);
      existing.tapoSpeed = Math.max(existing.tapoSpeed || 0, d.tapoSpeed || 0);
      existing.honeywellSpeed = Math.max(existing.honeywellSpeed || 0, d.honeywellSpeed || 0);
    });
    return Array.from(dateMap.values()).sort((a, b) => a.date.localeCompare(b.date));
  }, [rawUsageData, selectedUserId]);

  const currentEntityName = selectedUserId ? sidebarUsers.find(u => u.userId === selectedUserId)?.userName : "Global System";

  return (
    <div className="min-h-screen bg-[#F1F5F9] text-slate-900 p-4 md:p-8 space-y-6">
      <header className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
        <h1 className="text-3xl font-black italic uppercase tracking-tighter">System Monitor</h1>
        
        <div className="flex flex-wrap items-center gap-4">
          <div className="flex items-center gap-2 bg-slate-900 text-white px-4 py-2 rounded-2xl shadow-lg border border-slate-700">
            <FiAlertCircle className="text-rose-400" />
            <label className="text-[10px] font-black uppercase tracking-wider">Threshold:</label>
            <input
              type="number"
              value={adminMaxCalls}
              onChange={(e) => {
                const val = Number(e.target.value);
                setAdminMaxCalls(val);
                localStorage.setItem("adminMaxCalls", val);
              }}
              className="bg-slate-800 border-none text-xs font-bold text-rose-400 w-16 rounded-lg text-center focus:ring-0"
            />
          </div>

          <div className="flex items-center gap-2 bg-white p-2 rounded-2xl shadow-sm border border-slate-200 text-xs font-bold">
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="bg-transparent border-none p-0 px-2" />
            <span className="text-slate-300">-</span>
            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="bg-transparent border-none p-0 px-2" />
            <button onClick={fetchAnalytics} className="p-2.5 bg-blue-600 text-white rounded-xl active:scale-95"><FiRefreshCw className={loading ? "animate-spin" : ""} /></button>
          </div>
        </div>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <aside className="lg:col-span-3">
          <div className="bg-white rounded-[2rem] border border-slate-200 shadow-sm flex flex-col h-[750px] overflow-hidden">
            <div className="p-5 border-b border-slate-50 bg-slate-50/50">
              <div className="relative">
                <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <input 
                  type="text" 
                  placeholder="Search entity..." 
                  className="w-full pl-9 pr-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm outline-none" 
                  value={userSearch} 
                  onChange={(e) => setUserSearch(e.target.value)} 
                />
              </div>
            </div>
            <div className="overflow-y-auto flex-1 p-3 space-y-2">
              <button onClick={() => setSelectedUserId(null)} className={`w-full p-4 rounded-2xl transition-all flex items-center justify-between border-2 ${!selectedUserId ? "bg-slate-900 border-slate-900 text-white shadow-lg" : "bg-white border-transparent hover:bg-slate-50"}`}>
                <div className="flex items-center gap-3"><FiGlobe /><span className="text-xs font-black uppercase">Global System</span></div>
              </button>

             {sidebarUsers.map((u) => {
                const isOverLimit = Number(u.totalCalls) > Number(adminMaxCalls);
                const isActive = selectedUserId === u.userId;
                return (
                  <button
                    key={u.userId}
                    onClick={() => setSelectedUserId(u.userId)}
                    className={`w-full p-4 rounded-2xl transition-all flex items-center justify-between border-2 ${
                      isActive ? "bg-slate-900 border-slate-900 text-white shadow-lg" 
                      : isOverLimit ?  "bg-amber-50 border-amber-400 text-amber-900 animate-pulse" 
                      : "bg-white border-transparent hover:border-slate-100 text-slate-600"
                    }`}
                  >
                    <div className="text-left">
                      <div className="text-sm font-bold truncate w-28 uppercase">{u.userName}</div>
                      <div className="text-[9px] font-mono opacity-50 uppercase">ID: {u.userId.slice(-8)}</div>
                    </div>
                    <div className={`text-right text-xs font-black ${isOverLimit && !isActive ? "text-amber-600" : ""}`}>
                      {u.totalCalls.toLocaleString()}
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </aside>

        <main className="lg:col-span-9 space-y-6">
          {/* Chart Section */}
          <div className="bg-white rounded-[2rem] border border-slate-200 shadow-sm p-8">
            <div className="flex justify-between items-center mb-8">
              <h3 className="text-xl font-black uppercase italic tracking-tighter">{currentEntityName}</h3>
              <div className="flex bg-slate-100 p-1 rounded-xl">
                {['all', 'tapo', 'honeywell'].map(b => (
                  <button key={b} onClick={() => setActiveBrand(b)} className={`px-4 py-1.5 rounded-lg text-[10px] font-black uppercase transition-all ${activeBrand === b ? 'bg-white text-blue-600 shadow-sm' : 'text-slate-400'}`}>{b}</button>
                ))}
              </div>
            </div>
            <div className="h-[320px] w-full">
              <ResponsiveContainer>
                <AreaChart data={chartData}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
                  <XAxis dataKey="date" axisLine={false} tickLine={false} tick={{ fill: "#94a3b8", fontSize: 11, fontWeight: 700 }} dy={10} />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: "#94a3b8", fontSize: 11, fontWeight: 700 }} />
                  <Tooltip content={<ChartTooltip brand={activeBrand} />} />
                  <ReferenceLine y={adminMaxCalls} stroke="#ef4444" strokeDasharray="3 3" label={{ position: 'right', value: 'ALERT', fill: '#ef4444', fontSize: 10, fontWeight: 900 }} />
                  <Area type="monotone" dataKey={activeBrand === 'all' ? 'calls' : activeBrand} stroke="#3b82f6" strokeWidth={3} fill="#3b82f6" fillOpacity={0.05} animationDuration={500} />
                  <Line type="monotone" dataKey={activeBrand === 'all' ? 'speed' : `${activeBrand}Speed`} stroke="#10b981" strokeWidth={2} dot={{ r: 4 }} animationDuration={500} />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Logs Section */}
          <div className="bg-white rounded-[2rem] border border-slate-200 shadow-sm overflow-hidden flex flex-col">
            <div className="p-6 border-b border-slate-50 bg-slate-50/30">
               <div className="flex flex-wrap items-center gap-4">
                  <div className="flex flex-col gap-1">
                    <label className="text-[10px] font-black text-slate-400 uppercase">Action</label>
                    <input type="text" placeholder="sync..." value={logFilters.action} onChange={(e) => setLogFilters(p => ({...p, action: e.target.value}))} className="text-xs border-slate-200 rounded-xl px-3 py-2 w-32 outline-none" />
                  </div>
                  
                  {/* BRAND/API FILTER FOR LOGS */}
                  <div className="flex flex-col gap-1">
                    <label className="text-[10px] font-black text-slate-400 uppercase">Brand/API</label>
                    <select 
                      value={logFilters.api} 
                      onChange={(e) => setLogFilters(p => ({...p, api: e.target.value}))}
                      className="text-xs border-slate-200 rounded-xl px-3 py-2 bg-white font-bold"
                    >
                      <option value="">All Brands</option>
                      <option value="tapo">Tapo</option>
                      <option value="honeywell">Honeywell</option>
                    </select>
                  </div>

                  <div className="flex flex-col gap-1">
                    <label className="text-[10px] font-black text-slate-400 uppercase">Trigger Source</label>
                    <select 
                      value={logFilters.source} 
                      onChange={(e) => setLogFilters(p => ({...p, source: e.target.value}))}
                      className="text-xs border-slate-200 rounded-xl px-3 py-2 bg-white font-bold"
                    >
                      <option value="">All Sources</option>
                      <option value="cron">Cron Job</option>
                      <option value="user">User Manual</option>
                      <option value="system">System</option>
                      <option value="smartRestore">Smart Restore</option>
                    </select>
                  </div>

                  <div className="flex flex-col gap-1">
                    <label className="text-[10px] font-black text-slate-400 uppercase">Status</label>
                    <select 
                      value={logFilters.status} 
                      onChange={(e) => setLogFilters(p => ({...p, status: e.target.value}))}
                      className="text-xs border-slate-200 rounded-xl px-3 py-2 bg-white font-bold"
                    >
                      <option value="">All Status</option>
                      <option value="success">Success</option>
                      <option value="failed">Failed</option>
                    </select>
                  </div>

                  <button onClick={() => fetchUserLogs(1)} className="px-5 py-2 bg-slate-900 text-white text-[11px] font-black rounded-xl hover:bg-blue-600 transition-all mt-4 uppercase">Apply</button>
               </div>
            </div>

            <UsageLogsTable
              logs={logs}
              loading={logsLoading}
              /* ⚠️ Resolved from the UNFILTERED data, not sidebarUsers —
                 sidebarUsers is narrowed by the search box, so typing a search
                 that does not match the selected user's name would blank this
                 column while the rows below still belong to that user. */
              user={rawUsageData.find((d) => d.userId === selectedUserId)}
            />

            <div className="p-6 bg-slate-50 border-t flex items-center justify-between">
                <span className="text-xs font-bold text-slate-400 italic tracking-widest uppercase">Page {logsPage} of {logsTotalPages}</span>
                <div className="flex gap-2">
                  <button disabled={logsPage === 1} onClick={() => fetchUserLogs(logsPage - 1)} className="p-2 bg-white border rounded-xl disabled:opacity-30"><FiChevronLeft /></button>
                  <button disabled={logsPage === logsTotalPages} onClick={() => fetchUserLogs(logsPage + 1)} className="p-2 bg-white border rounded-xl disabled:opacity-30"><FiChevronRight /></button>
                </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

const ChartTooltip = ({ active, payload, label, brand }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-slate-900 p-4 rounded-2xl shadow-xl text-white border border-slate-800">
        <p className="text-[10px] font-black text-blue-400 uppercase mb-2 tracking-widest">{label} — {brand}</p>
        <div className="flex gap-4">
          <div>
            <div className="text-[9px] text-slate-400 uppercase">Calls</div>
            <div className="text-lg font-black tracking-tighter">{payload[0].value}</div>
          </div>
          <div className="w-[1px] bg-slate-700 h-8 mt-1" />
          <div>
            <div className="text-[9px] text-slate-400 uppercase">Peak</div>
            <div className="text-lg font-black text-emerald-400 tracking-tighter">{payload[1]?.value} req/s</div>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default UsageMonitoring;